import { IconsProps } from '@/types/shared'
import React from 'react'

const MergeIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                fill="currentColor"
            >
                <path d="M480-120 320-280l56-56 64 64v-167q-73-11-121.5-68.5T270-640q0-83 58.5-141.5T470-840q83 0 141.5 58.5T670-640q0 75-48.5 132.5T500-439v167l64-64 56 56-140 160ZM470-520q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z" />
            </svg>
        </div>
    )
}

export default MergeIcons
